/**
 * Agent package search displayed price from the canonical search-card room.
 * Same formula as resolveAgentPackageDisplayedPrice — kept free of SearchContext
 * so search-results sort/filter tests can import it.
 */
import {
  resolveSearchCardRoom,
  shouldUseDealPricingSnapshot,
} from "./resolveSearchCardRoom";

export function computeCanonicalSearchCardDisplayedPrice({
  fullDeal,
  extendedDeal = null,
  shortenedDeal = null,
  occupancyRooms = null,
  calculateLDSDealFareForRoomsComposition,
  ignorePricingSnapshot = false,
} = {}) {
  if (!fullDeal || typeof calculateLDSDealFareForRoomsComposition !== "function") {
    return null;
  }
  try {
    const resolution = resolveSearchCardRoom({
      fullDeal,
      shortenedDeal,
      extendedDeal,
      occupancyRooms,
    });
    if (!ignorePricingSnapshot) {
      const snapshot = fullDeal?.pricingSnapshot;
      const pricingSnapshotCandidate =
        Number(snapshot?.finalClientPriceIls) ||
        Number(snapshot?.finalPriceIls) ||
        Number(snapshot?.final_price) ||
        null;
      if (
        Number.isFinite(pricingSnapshotCandidate) &&
        Number(pricingSnapshotCandidate) > 0
      ) {
        const snapshotOk = shouldUseDealPricingSnapshot(resolution, snapshot);
        if (snapshotOk) {
          return Number(pricingSnapshotCandidate);
        }
      }
    }
    const dealRef = resolution.usedRoomMatrix
      ? resolution.composeDealRef
      : extendedDeal || null;
    const fare = calculateLDSDealFareForRoomsComposition(fullDeal, dealRef);
    const v = Number(fare?.ourTotalFare?.priceWithCommissionAndCreditCardFee);
    return Number.isFinite(v) && v > 0 ? v : null;
  } catch {
    return null;
  }
}
